import { Action, createReducer, on } from '@ngrx/store';
import { IFormErrorNotification, INotification } from '../models/notification.model';
import * as NotificationActions from './notification.actions';

export const notificationFeatureKey = 'carm-notifications';

export interface NotificationState {
  notification: INotification;
  deploymentNotification: INotification;
  pageNotification: INotification;
  formErrorNotification: IFormErrorNotification;
}

export const initialState: NotificationState = {
  notification: null,
  deploymentNotification: null,
  pageNotification: null,
  formErrorNotification: null,
};

const notificationActionReducer = createReducer(
  initialState,

  on(NotificationActions.setNotification, (state, {data}) => ({...state, notification: data })),
  on(NotificationActions.setDeploymentNotification, (state, {data}) => ({...state, deploymentNotification: data })),
  on(NotificationActions.setPageNotification, (state, {data}) => ({...state, pageNotification: data })),
  on(NotificationActions.setFormErrorNotification, (state, {data}) => ({...state, formErrorNotification: data })),
  on(NotificationActions.clearNotification, (state) => ({...state, notification: null})),
  on(NotificationActions.clearDeploymentNotification, (state) => ({...state, deploymentNotification: null})),
  on(NotificationActions.clearPageNotification, (state) => ({...state, pageNotification: null})),
  on(NotificationActions.clearFormErrorNotification, (state) => ({...state, formErrorNotification: null})),
);

export function notificationReducer(state: NotificationState | undefined, action: Action) {
  return notificationActionReducer(state, action);
}
